import { render } from "./WhatPerson.vue?vue&type=template&id=a4ef7af2"
import script from "./WhatPerson.vue?vue&type=script&lang=js"
export * from "./WhatPerson.vue?vue&type=script&lang=js"
script.render = render

export default script